export class Shift {
    _id: string = '';
    created_at: string = '';
    updated_at: string = '';
    brand_id: string = '';
    branch_id: string = '';
    branch_name: string = '';
    name: string = '';
    start_time: string = '';
    end_time: string = '';
    status: number = 1;
    total_check_in: number = 1;
    is_have_check_in: number = 1;
    constructor(data?: Partial<Shift>) {
        Object.assign(this, data);
    }
}